import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { checkCondition } from './helpers';
import { IState } from '@/state/IState';
import { ProjectPermissions, PermissionCheck } from '@/types';

const mapStateToProps = (state: IState) => ({ project: state.global.activeProject });

type OwnProps = ReturnType<typeof mapStateToProps> & {
    condition: PermissionCheck<ProjectPermissions>;
    fallbackDisplay?: ReactNode;
    children?: ReactNode;
};

const ProjectPermissionToggle: React.FC<OwnProps> = ({ children, project, condition, fallbackDisplay }) => {
    if (project && project.permissions && checkCondition(project.permissions, condition)) {
        return <>{children}</>;
    }

    return <>{fallbackDisplay || null}</>;
};

export default connect(mapStateToProps)(ProjectPermissionToggle);